// extracted by mini-css-extract-plugin
export default {"title":"yaa-z","warning":"zaa-z","sizeOptionsLegendText":"Aaa-z"};